import React from 'react';
import Flags from 'country-flag-icons/react/3x2';

const Flag = ({ countryCode = '', ...props }) => {
  // Convert country code to uppercase
  const countryCodeUpper = countryCode.toUpperCase();

  // Get the flag component
  const FlagComponent = Flags[countryCodeUpper];

  // Return the flag component if it exists, otherwise return null
  return FlagComponent ? <FlagComponent {...props} /> : null;
};

export default Flag;
